export const PrivacyPolicy = () => (
	<div className="policy-container">
		<h1>Privacy Policy</h1>
		<p>In compliance with the IT Act 2000, we protect your data as follows:</p>
		<ul>
			<li><strong>Data Collection:</strong> We collect Name, Phone, and Location to facilitate services.</li>
			<li><strong>Data Sharing:</strong> Your data is shared only with the specific provider you book.</li>
			<li>
				<strong>Communications:</strong><br />
				<strong>WhatsApp Notifications:</strong> By providing your mobile number, you agree to receive automated transactional notifications,
				such as One-Time Passwords (OTP) and service lead updates, via WhatsApp.<br /><br />
				These communications are powered by the WhatsApp Business Platform (Meta).
				We share only the necessary data (e.g., your name and phone number) with Meta to facilitate these messages.<br /><br />
				You can opt-out at any time by replying "STOP" or contacting our support at <strong>contact@mybharatservice.com</strong>.
			</li>

			<li><strong>Security:</strong> We use industry-standard encryption to protect your information.</li>
			<li><strong>Rights:</strong> You can request data deletion at any time via email.</li>
		</ul>
		{/* Footer for Legal Connection */}
		<footer style={{ marginTop: '30px', borderTop: '1px solid #ddd', paddingTop: '10px', fontSize: '0.85rem' }}>
			<p>MyBharatService is a registered brand name of <strong>CITIKART ONLINE SERVICE PRIVATE LIMITED</strong>. All rights reserved.</p>
		</footer>
	</div>
);
